export const getBookWaveformLoaderId = (chapterId) => {
  return "FBW_" + chapterId;
};
